import React, { FC, useEffect, useState } from 'react';
import styles from './bim.module.scss';
import { ObraBim } from '../../../types/ObraDetails';
import DataBim from './dataBim/dataBim';
import NoDataPicture from '../components/noDataPicture/noDataPicture';
import { useTranslation } from 'react-i18next';
import bimNoData from '../../../assets/bim_no_data.svg';
import bimNoEvaluated from '../../../assets/bim_no_evaluated.svg';
import UsosBim from './usosBim/usosBim';
import ObrasAPI from '../../../services/APIObras';
import ErrorDetails from '../components/ErrorDetails/ErrorDetails';
import { BimLoadingSkeleton } from './components/bimLoadingSkeleton/bimLoadingSkeleton';

interface BimProps {
  codCentro: string;
  projectId?: string;
  projectIdLoading: boolean;
  projectIdError: boolean;
}

const Bim: FC<BimProps> = (props) => {
  const { codCentro, projectId, projectIdLoading, projectIdError } = props;
  const [t] = useTranslation();
  const [bim, setBim] = useState<ObraBim>();
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    const api = ObrasAPI.getInstance();
    setBim(undefined);
    setLoadError(false);
    if (!projectId) return;

    api.getObraBimAPI(codCentro, projectId)
      .then((bimResponse) => {
        setBim(bimResponse);
      })
      .catch(() => {
        setLoadError(true);
      });
  }, [codCentro, projectId]);

  if (loadError || projectIdError) return <ErrorDetails />;
  if (!bim || projectIdLoading) return <BimLoadingSkeleton />;

  const showNoDataPictureConfigurationMap: Record<number, { picture: string; text: string }> = {
    1: {
      picture: bimNoData,
      text: t('details.bim.noEvaluatedData')
    },
    6: {
      picture: bimNoEvaluated,
      text: t('details.bim.noData')
    }
  };

  let noBimData = false;
  let noData: { picture: string; text: string } = {
    picture: bimNoEvaluated,
    text: t('details.bim.noEvaluatedData')
  };

  if (!bim.requisitos) {
    noBimData = true;
    noData = {
      picture: bimNoData,
      text: t('details.bim.noData')
    };
  } else if (bim.requisitos in showNoDataPictureConfigurationMap) {
    noBimData = true;
    noData = showNoDataPictureConfigurationMap[bim.requisitos];
  }

  const sourceName = bim.bimProyecto
    ? t('tagsOverlay.nameCode')
    : t('details.licitacion');
  const updateDate = bim.fecModif ? ` - ${bim.fecModif}` : '';
  const dataSource = `${sourceName} ${updateDate}`;

  return (
    <div
      data-testid="bim-test"
      className={styles.bimContainer} >
      {
        !noBimData ?
          <>
            <div className={styles.lastUpdate} id='lastUpdate'>{t('details.dataSource')}:
              <span className={styles.lastUpdateDate} id='lastUpdateDate'> {dataSource}</span>
            </div>
            <DataBim bim={bim} />
            <div className={styles.section}>
              {bim.usosBIM?.length > 0 && <UsosBim usages={bim.usosBIM} />}
            </div>
          </>
          : <NoDataPicture
            id='bim-nodata'
            picture={noData.picture}
            text={noData.text}
          />
      }
      <div className='footer' style={{marginBottom: '75px'}}></div>
    </div >);
};

export default Bim;
